export const css = {
	oneaction: '_1HMHYa7C',
	' _key': 'afcpe-theme/afcpe/micro/quiz-widgets/pretest-review'
};

export default css;
